import * as i0 from '@angular/core';
import { Component, Inject, Input, HostBinding, ViewChild, Directive, EventEmitter, forwardRef, TemplateRef, Output, ContentChild, NgModule } from '@angular/core';
import * as i1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@ngbracket/ngx-layout/flex';
import * as i4 from '@ngbracket/ngx-layout/extended';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import * as i2$1 from 'ng2-charts';
import { NgChartsModule } from 'ng2-charts';
import * as i2$2 from '@angular/forms';
import { FormControl, Validators, NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i3$1 from 'ngx-carousel-ease';
import { CarouselModule } from 'ngx-carousel-ease';
import * as i2$3 from '@angular/material/snack-bar';
import { MAT_SNACK_BAR_DATA, MatSnackBarModule } from '@angular/material/snack-bar';
import * as i1$1 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i4$1 from '@angular/material/paginator';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import * as i3$2 from '@angular/material/table';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import * as i4$2 from '@insight/shared';
import { IMaskModule } from '@insight/shared';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTreeModule } from '@angular/material/tree';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatTabsModule } from '@angular/material/tabs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
function AlertComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "i", 4);
    i0.ɵɵelementContainerEnd();
  }
}
function AlertComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "i", 5);
    i0.ɵɵelementContainerEnd();
  }
}
function AlertComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "i", 6);
    i0.ɵɵelementContainerEnd();
  }
}
function AlertComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "i", 7);
    i0.ɵɵelementContainerEnd();
  }
}
function LoadingComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "label");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("color", ctx_r0.textColor);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.text);
  }
}
function BarComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "canvas", 1);
    i0.ɵɵlistener("chartClick", function BarComponent_ng_container_0_Template_canvas_chartClick_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onChartClicked($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("data", ctx_r1.chartData)("plugins", ctx_r1.plugins)("options", ctx_r1.options);
  }
}
function BarComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "loading");
    i0.ɵɵelementContainerEnd();
  }
}
function ConfirmComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "i", 6);
    i0.ɵɵelementContainerEnd();
  }
}
function ConfirmComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "i", 7);
    i0.ɵɵelementContainerEnd();
  }
}
function ConfirmComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "i", 8);
    i0.ɵɵelementContainerEnd();
  }
}
function ConfirmComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "i", 9);
    i0.ɵɵelementContainerEnd();
  }
}
const _c0 = ["*"];
function DeleteComponent_error_message_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "error-message");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.errorMessage);
  }
}
function ThumbComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "img", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("portrait", ctx_r0.isPortrait);
    i0.ɵɵproperty("src", ctx_r0.src, i0.ɵɵsanitizeUrl);
  }
}
function ImageViewerComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelement(2, "thumb", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const image_r1 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("src", image_r1.src);
  }
}
function LoadingButtonComponent_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "span", 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.loadingText, " ");
  }
}
function LoadingButtonComponent_ng_container_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "span", 3);
    i0.ɵɵelementContainerEnd();
  }
}
function LoadingButtonComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LoadingButtonComponent_ng_container_1_ng_container_1_Template, 3, 1, "ng-container", 1)(2, LoadingButtonComponent_ng_container_1_ng_container_2_Template, 2, 0, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.loadingText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.loadingText);
  }
}
function LoadingButtonComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵprojection(1);
    i0.ɵɵelementContainerEnd();
  }
}
const _c1 = a0 => ({
  $implicit: a0
});
const _c2 = () => [10, 50, 100];
function DialogComponent_h2_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.title);
  }
}
function DialogComponent_ng_container_10_mat_header_cell_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell", 24);
    i0.ɵɵtext(1, " No. ");
    i0.ɵɵelementEnd();
  }
}
function DialogComponent_ng_container_10_mat_cell_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell", 25);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", row_r2.no, " ");
  }
}
function DialogComponent_ng_container_10_mat_header_cell_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell", 26);
    i0.ɵɵtext(1, "Description");
    i0.ɵɵelementEnd();
  }
}
function DialogComponent_ng_container_10_mat_cell_8_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DialogComponent_ng_container_10_mat_cell_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell", 27);
    i0.ɵɵtemplate(1, DialogComponent_ng_container_10_mat_cell_8_ng_container_1_Template, 1, 0, "ng-container", 28);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.optionTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c1, row_r3));
  }
}
function DialogComponent_ng_container_10_mat_header_cell_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-header-cell", 29);
  }
}
function DialogComponent_ng_container_10_mat_cell_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-cell", 29)(1, "button", 30);
    i0.ɵɵlistener("click", function DialogComponent_ng_container_10_mat_cell_11_Template_button_click_1_listener() {
      const row_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.select(row_r5));
    });
    i0.ɵɵelement(2, "i", 31);
    i0.ɵɵelementEnd()();
  }
}
function DialogComponent_ng_container_10_mat_header_row_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-header-row");
  }
}
function DialogComponent_ng_container_10_mat_row_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-row");
  }
}
function DialogComponent_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-table", 12, 0);
    i0.ɵɵelementContainerStart(3, 13);
    i0.ɵɵtemplate(4, DialogComponent_ng_container_10_mat_header_cell_4_Template, 2, 0, "mat-header-cell", 14)(5, DialogComponent_ng_container_10_mat_cell_5_Template, 2, 1, "mat-cell", 15);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(6, 16);
    i0.ɵɵtemplate(7, DialogComponent_ng_container_10_mat_header_cell_7_Template, 2, 0, "mat-header-cell", 17)(8, DialogComponent_ng_container_10_mat_cell_8_Template, 2, 4, "mat-cell", 18);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(9, 19);
    i0.ɵɵtemplate(10, DialogComponent_ng_container_10_mat_header_cell_10_Template, 1, 0, "mat-header-cell", 20)(11, DialogComponent_ng_container_10_mat_cell_11_Template, 3, 0, "mat-cell", 21);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵtemplate(12, DialogComponent_ng_container_10_mat_header_row_12_Template, 1, 0, "mat-header-row", 22)(13, DialogComponent_ng_container_10_mat_row_13_Template, 1, 0, "mat-row", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("dataSource", ctx_r0.options);
    i0.ɵɵadvance(11);
    i0.ɵɵproperty("matHeaderRowDef", ctx_r0.displayedColumns)("matHeaderRowDefSticky", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("matRowDefColumns", ctx_r0.displayedColumns);
  }
}
function DialogComponent_ng_container_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "loading", 32);
    i0.ɵɵelementContainerEnd();
  }
}
function DialogComponent_ng_container_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "mat-paginator", 33);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("pageSizeOptions", i0.ɵɵpureFunction0(1, _c2));
  }
}
function DialogComponent_mat_dialog_actions_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-dialog-actions", 34)(1, "button", 35);
    i0.ɵɵlistener("click", function DialogComponent_mat_dialog_actions_13_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.add());
    });
    i0.ɵɵelement(2, "i", 36);
    i0.ɵɵtext(3, "Add ");
    i0.ɵɵelementEnd()();
  }
}
function OptionDialogComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 3);
    i0.ɵɵelement(2, "i", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
}
function OptionDialogComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 5);
    i0.ɵɵlistener("click", function OptionDialogComponent_ng_container_3_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.openDialog());
    });
    i0.ɵɵelement(2, "i", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
}
let AlertComponent = /*#__PURE__*/(() => {
  class AlertComponent {
    dialogRef;
    data;
    title;
    description;
    type = 'information';
    constructor(dialogRef, data) {
      this.dialogRef = dialogRef;
      this.data = data;
    }
    ngOnInit() {
      this.title = this.data.title;
      this.description = this.data.description;
      this.type = this.data.type;
    }
    submit() {
      this.dialogRef.close(true);
    }
    static ɵfac = function AlertComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AlertComponent)(i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AlertComponent,
      selectors: [["app-alert"]],
      decls: 10,
      vars: 7,
      consts: [["fxLayout", "column", "fxLayoutAlign", "center center", 3, "ngClass"], [4, "ngIf"], [1, "text-secondary", 3, "innerHtml"], [1, "btn", "btn-primary", 3, "click"], [1, "fas", "fa-info-circle"], [1, "fas", "fa-check-circle"], [1, "fas", "fa-exclamation-circle"], [1, "fas", "fa-times-circle"]],
      template: function AlertComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "mat-dialog-content", 0);
          i0.ɵɵtemplate(1, AlertComponent_ng_container_1_Template, 2, 0, "ng-container", 1)(2, AlertComponent_ng_container_2_Template, 2, 0, "ng-container", 1)(3, AlertComponent_ng_container_3_Template, 2, 0, "ng-container", 1)(4, AlertComponent_ng_container_4_Template, 2, 0, "ng-container", 1);
          i0.ɵɵelementStart(5, "h4");
          i0.ɵɵtext(6);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(7, "p", 2);
          i0.ɵɵelementStart(8, "button", 3);
          i0.ɵɵlistener("click", function AlertComponent_Template_button_click_8_listener() {
            return ctx.submit();
          });
          i0.ɵɵtext(9, " OK ");
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", ctx.type);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.type === "information");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.type === "success");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.type === "warning");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.type === "danger");
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.title);
          i0.ɵɵadvance();
          i0.ɵɵproperty("innerHtml", ctx.description, i0.ɵɵsanitizeHtml);
        }
      },
      dependencies: [i2.NgClass, i2.NgIf, i1.MatDialogContent, i3.DefaultLayoutDirective, i3.DefaultLayoutAlignDirective, i4.DefaultClassDirective],
      styles: [".mat-mdc-dialog-content[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-size:90px;margin-top:40px;margin-bottom:40px}.mat-mdc-dialog-content[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{font-weight:600}.mat-mdc-dialog-content[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin-top:15px;text-align:center}.mat-mdc-dialog-content[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin-top:30px;margin-bottom:10px;width:100px}.mat-mdc-dialog-content.information[_ngcontent-%COMP%]   i[_ngcontent-%COMP%], .mat-mdc-dialog-content.information[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{color:var(--bs-primary)}.mat-mdc-dialog-content.success[_ngcontent-%COMP%]   i[_ngcontent-%COMP%], .mat-mdc-dialog-content.success[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{color:var(--bs-success)}.mat-mdc-dialog-content.warning[_ngcontent-%COMP%]   i[_ngcontent-%COMP%], .mat-mdc-dialog-content.warning[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{color:var(--bs-warning)}.mat-mdc-dialog-content.danger[_ngcontent-%COMP%]   i[_ngcontent-%COMP%], .mat-mdc-dialog-content.danger[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{color:var(--bs-danger)}"]
    });
  }
  return AlertComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const colors = ['#fb6b1d', '#e83b3b', '#831c5d', '#c32454', '#f04f78', '#f68181', '#fca790', '#e3c896', '#ab947a', '#966c6c', '#625565', '#3e3546', '#0b5e65', '#0b8a8f', '#1ebc73', '#91db69', '#fbff86', '#fbb954', '#cd683d', '#9e4539', '#7a3045', '#6b3e75', '#905ea9', '#a884f3', '#eaaded', '#8fd3ff', '#4d9be6', '#4d65b4', '#484a77', '#30e1b9', '#8ff8e2'];
let LoadingComponent = /*#__PURE__*/(() => {
  class LoadingComponent {
    text = 'Please wait..';
    textColor = '#354052';
    constructor() {}
    ngOnInit() {}
    static ɵfac = function LoadingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LoadingComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: LoadingComponent,
      selectors: [["loading"]],
      inputs: {
        text: "text",
        textColor: "textColor"
      },
      decls: 2,
      vars: 1,
      consts: [["role", "status", 1, "spinner-border", "text-primary"], [4, "ngIf"]],
      template: function LoadingComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", 0);
          i0.ɵɵtemplate(1, LoadingComponent_ng_container_1_Template, 3, 3, "ng-container", 1);
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.text);
        }
      },
      dependencies: [i2.NgIf],
      styles: ["[_nghost-%COMP%]{flex-direction:column;box-sizing:border-box;display:flex;place-content:center;align-items:center;min-height:400px}[_nghost-%COMP%]   label[_ngcontent-%COMP%]{white-space:nowrap;margin-bottom:0;margin-top:10px}"]
    });
  }
  return LoadingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BarComponent = /*#__PURE__*/(() => {
  class BarComponent {
    // @Input() data: any[] = [];
    datasets = [];
    labels = [];
    backgroundColors = [];
    plugins = [ChartDataLabels];
    options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        datalabels: {
          anchor: 'center',
          align: 'center',
          color: '#000000',
          formatter: function (value, context) {
            const val = value;
            if (!val) {
              return '';
            }
            return val;
          }
        },
        legend: {
          display: false
        }
      },
      scales: {
        y: {
          stacked: true,
          ticks: {
            stepSize: 10,
            font: {
              family: 'OpenSans'
            }
          },
          beginAtZero: true
        },
        x: {
          stacked: true,
          ticks: {
            stepSize: 10,
            font: {
              family: 'OpenSans'
            }
          }
        }
      },
      elements: {
        point: {
          radius: 5,
          hitRadius: 5,
          hoverRadius: 8
        }
      },
      animation: {
        duration: 1,
        onComplete: () => {}
      }
    };
    chartData = {};
    isInitialized = false;
    ngOnInit() {
      const dataLength = this.datasets.length;
      const backgroundColors = this.backgroundColors;
      if (backgroundColors.length === 0) {
        for (let i = 0; i < dataLength; i++) {
          backgroundColors.push(colors[i]);
        }
      }
      this.chartData = {
        labels: this.labels,
        datasets: this.datasets
      };
      console.log('this.chartData', this.chartData);
      this.isInitialized = true;
    }
    onChartClicked(e) {
      console.log(e);
    }
    static ɵfac = function BarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BarComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BarComponent,
      selectors: [["bar"]],
      inputs: {
        datasets: "datasets",
        labels: "labels",
        backgroundColors: "backgroundColors",
        plugins: "plugins"
      },
      decls: 2,
      vars: 2,
      consts: [[4, "ngIf"], ["baseChart", "", "type", "bar", 3, "chartClick", "data", "plugins", "options"]],
      template: function BarComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, BarComponent_ng_container_0_Template, 2, 3, "ng-container", 0)(1, BarComponent_ng_container_1_Template, 2, 0, "ng-container", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.isInitialized);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.isInitialized);
        }
      },
      dependencies: [i2.NgIf, i2$1.BaseChartDirective, LoadingComponent]
    });
  }
  return BarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DoughnutComponent = /*#__PURE__*/(() => {
  class DoughnutComponent {
    static ɵfac = function DoughnutComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DoughnutComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DoughnutComponent,
      selectors: [["doughnut"]],
      decls: 2,
      vars: 0,
      template: function DoughnutComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "p");
          i0.ɵɵtext(1, "doughnut nih works!");
          i0.ɵɵelementEnd();
        }
      }
    });
  }
  return DoughnutComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LegendComponent = /*#__PURE__*/(() => {
  class LegendComponent {
    static ɵfac = function LegendComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LegendComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: LegendComponent,
      selectors: [["legend"]],
      decls: 2,
      vars: 0,
      template: function LegendComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "p");
          i0.ɵɵtext(1, "legend nih works!");
          i0.ɵɵelementEnd();
        }
      }
    });
  }
  return LegendComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ConfirmComponent = /*#__PURE__*/(() => {
  class ConfirmComponent {
    dialogRef;
    data;
    title;
    description;
    type = 'information';
    constructor(dialogRef, data) {
      this.dialogRef = dialogRef;
      this.data = data;
    }
    ngOnInit() {
      this.title = this.data.title;
      this.description = this.data.description;
      this.type = this.data.type;
    }
    submit() {
      this.dialogRef.close(true);
    }
    cancel() {
      this.dialogRef.close(false);
    }
    static ɵfac = function ConfirmComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ConfirmComponent)(i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ConfirmComponent,
      selectors: [["app-confirm"]],
      decls: 13,
      vars: 7,
      consts: [["fxLayout", "column", "fxLayoutAlign", "center center", 3, "ngClass"], [4, "ngIf"], [1, "text-secondary", 3, "innerHtml"], ["fxLayout", "", "fxLayoutGap", "10px"], [1, "btn", "btn-primary", 3, "click"], [1, "btn", "btn-danger", 3, "click"], [1, "fas", "fa-info-circle"], [1, "fas", "fa-check-circle"], [1, "fas", "fa-exclamation-circle"], [1, "fas", "fa-times-circle"]],
      template: function ConfirmComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "mat-dialog-content", 0);
          i0.ɵɵtemplate(1, ConfirmComponent_ng_container_1_Template, 2, 0, "ng-container", 1)(2, ConfirmComponent_ng_container_2_Template, 2, 0, "ng-container", 1)(3, ConfirmComponent_ng_container_3_Template, 2, 0, "ng-container", 1)(4, ConfirmComponent_ng_container_4_Template, 2, 0, "ng-container", 1);
          i0.ɵɵelementStart(5, "h4");
          i0.ɵɵtext(6);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(7, "p", 2);
          i0.ɵɵelementStart(8, "div", 3)(9, "button", 4);
          i0.ɵɵlistener("click", function ConfirmComponent_Template_button_click_9_listener() {
            return ctx.submit();
          });
          i0.ɵɵtext(10, " Confirm ");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(11, "button", 5);
          i0.ɵɵlistener("click", function ConfirmComponent_Template_button_click_11_listener() {
            return ctx.cancel();
          });
          i0.ɵɵtext(12, " Cancel ");
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", ctx.type);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.type === "information");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.type === "success");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.type === "warning");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.type === "danger");
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.title);
          i0.ɵɵadvance();
          i0.ɵɵproperty("innerHtml", ctx.description, i0.ɵɵsanitizeHtml);
        }
      },
      dependencies: [i2.NgClass, i2.NgIf, i1.MatDialogContent, i3.DefaultLayoutDirective, i3.DefaultLayoutGapDirective, i3.DefaultLayoutAlignDirective, i4.DefaultClassDirective],
      styles: [".mat-mdc-dialog-content[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-size:90px;margin-top:40px;margin-bottom:40px}.mat-mdc-dialog-content[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{font-weight:600;text-align:center}.mat-mdc-dialog-content[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin-top:15px;text-align:center}.mat-mdc-dialog-content[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin-top:30px;margin-bottom:10px;width:100px}.mat-mdc-dialog-content.information[_ngcontent-%COMP%]   i[_ngcontent-%COMP%], .mat-mdc-dialog-content.information[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{color:var(--bs-primary)}.mat-mdc-dialog-content.success[_ngcontent-%COMP%]   i[_ngcontent-%COMP%], .mat-mdc-dialog-content.success[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{color:var(--bs-success)}.mat-mdc-dialog-content.warning[_ngcontent-%COMP%]   i[_ngcontent-%COMP%], .mat-mdc-dialog-content.warning[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{color:var(--bs-warning)}.mat-mdc-dialog-content.danger[_ngcontent-%COMP%]   i[_ngcontent-%COMP%], .mat-mdc-dialog-content.danger[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{color:var(--bs-danger)}"]
    });
  }
  return ConfirmComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ErrorMessageComponent = /*#__PURE__*/(() => {
  class ErrorMessageComponent {
    constructor() {}
    ngOnInit() {}
    static ɵfac = function ErrorMessageComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ErrorMessageComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ErrorMessageComponent,
      selectors: [["error-message"]],
      ngContentSelectors: _c0,
      decls: 2,
      vars: 0,
      template: function ErrorMessageComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "p");
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
        }
      },
      styles: ["p[_ngcontent-%COMP%]{font-size:14px;padding:6px 30px;border:1px solid #ed1c24;color:#ed1c24;background-color:#fde4e5;margin:0;line-height:normal;border-radius:3.5px}p[_ngcontent-%COMP%]:empty{display:none}"]
    });
  }
  return ErrorMessageComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DeleteComponent = /*#__PURE__*/(() => {
  class DeleteComponent {
    dialogRef;
    data;
    formBuilder;
    title;
    description;
    placeholder;
    formGroup;
    deleteReason;
    formSubmitAttempt = false;
    errorMessage;
    constructor(dialogRef, data, formBuilder) {
      this.dialogRef = dialogRef;
      this.data = data;
      this.formBuilder = formBuilder;
    }
    ngOnInit() {
      this.title = this.data.title;
      this.description = this.data.description;
      this.placeholder = this.data.placeholder || 'Type your reason here ...';
      this.deleteReason = new FormControl(null, [Validators.required]);
      this.formGroup = this.formBuilder.group({
        deleteReason: this.deleteReason
      });
    }
    submit() {
      this.formSubmitAttempt = true;
      if (this.formGroup.invalid) {
        this.errorMessage = 'Please fill in all required field';
        return;
      }
      this.dialogRef.close(this.deleteReason.value);
    }
    cancel() {
      this.dialogRef.close(false);
    }
    static ɵfac = function DeleteComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DeleteComponent)(i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i2$2.FormBuilder));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DeleteComponent,
      selectors: [["app-delete"]],
      decls: 16,
      vars: 7,
      consts: [["fxLayout", "column"], ["fxLayout", "column", "fxLayoutAlign", "center center"], [1, "fas", "fa-times-circle"], [1, "text-secondary"], ["novalidate", "", "fxLayout", "column", 1, "needs-validation", 3, "ngSubmit", "formGroup"], [1, "form-group"], ["formControlName", "deleteReason", "rows", "5", 1, "form-control", 3, "placeholder"], [4, "ngIf"], ["fxLayout", "", "fxLayoutGap", "10px", "fxLayoutAlign", "center center"], [1, "btn", "btn-primary", 3, "click"], [1, "btn", "btn-danger", 3, "click"]],
      template: function DeleteComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "mat-dialog-content", 0)(1, "div", 1);
          i0.ɵɵelement(2, "i", 2);
          i0.ɵɵelementStart(3, "h4");
          i0.ɵɵtext(4);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "p", 3);
          i0.ɵɵtext(6);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(7, "form", 4);
          i0.ɵɵlistener("ngSubmit", function DeleteComponent_Template_form_ngSubmit_7_listener() {
            return ctx.submit();
          });
          i0.ɵɵelementStart(8, "div", 5);
          i0.ɵɵelement(9, "textarea", 6);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(10, DeleteComponent_error_message_10_Template, 2, 1, "error-message", 7);
          i0.ɵɵelementStart(11, "div", 8)(12, "button", 9);
          i0.ɵɵlistener("click", function DeleteComponent_Template_button_click_12_listener() {
            return ctx.submit();
          });
          i0.ɵɵtext(13, " Confirm ");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(14, "button", 10);
          i0.ɵɵlistener("click", function DeleteComponent_Template_button_click_14_listener() {
            return ctx.cancel();
          });
          i0.ɵɵtext(15, " Cancel ");
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate(ctx.title);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.description);
          i0.ɵɵadvance();
          i0.ɵɵproperty("formGroup", ctx.formGroup);
          i0.ɵɵadvance(2);
          i0.ɵɵclassProp("is-invalid", ctx.deleteReason.invalid && ctx.formSubmitAttempt);
          i0.ɵɵproperty("placeholder", ctx.placeholder);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.errorMessage);
        }
      },
      dependencies: [i2.NgIf, i1.MatDialogContent, i3.DefaultLayoutDirective, i3.DefaultLayoutGapDirective, i3.DefaultLayoutAlignDirective, i2$2.ɵNgNoValidate, i2$2.DefaultValueAccessor, i2$2.NgControlStatus, i2$2.NgControlStatusGroup, i2$2.FormGroupDirective, i2$2.FormControlName, ErrorMessageComponent],
      styles: [".mat-mdc-dialog-content[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-size:90px;margin-top:40px;margin-bottom:40px}.mat-mdc-dialog-content[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{font-weight:600;text-align:center}.mat-mdc-dialog-content[_ngcontent-%COMP%]   i[_ngcontent-%COMP%], .mat-mdc-dialog-content[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{color:var(--bs-danger)}.mat-mdc-dialog-content[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{text-align:center}.mat-mdc-dialog-content[_ngcontent-%COMP%]   form[_ngcontent-%COMP%]{margin-top:25px}.mat-mdc-dialog-content[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin-top:10px;margin-bottom:5px;width:100px}"]
    });
  }
  return DeleteComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ImageHolderComponent = /*#__PURE__*/(() => {
  class ImageHolderComponent {
    el;
    src;
    borderRadius = "6px";
    isPortrait;
    styleBorderRadius;
    constructor(el) {
      this.el = el;
    }
    ngOnInit() {
      this.isPortrait = false;
      this.styleBorderRadius = this.borderRadius;
    }
    ngAfterViewInit() {
      const img = new Image();
      img.addEventListener('load', result => {
        const el = this.el.nativeElement;
        const elWidth = el.clientWidth;
        const elHeight = el.clientHeight;
        this.isPortrait = false;
        const imgWidth = img.naturalWidth;
        const imgHeight = img.naturalHeight;
        const calcHeight = imgHeight / elHeight;
        const calcWidth = imgWidth / calcHeight;
        if (calcWidth <= elWidth) {
          this.isPortrait = true;
        }
        if (imgHeight >= imgWidth) {
          this.isPortrait = true;
        }
      });
      img.src = this.src;
    }
    static ɵfac = function ImageHolderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ImageHolderComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ImageHolderComponent,
      selectors: [["image-holder"]],
      hostVars: 2,
      hostBindings: function ImageHolderComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵstyleProp("border-radius", ctx.styleBorderRadius);
        }
      },
      inputs: {
        src: "src",
        borderRadius: "borderRadius"
      },
      decls: 1,
      vars: 3,
      consts: [[3, "src"]],
      template: function ImageHolderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "img", 0);
        }
        if (rf & 2) {
          i0.ɵɵclassProp("portrait", ctx.isPortrait);
          i0.ɵɵproperty("src", ctx.src, i0.ɵɵsanitizeUrl);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block;position:relative;overflow:hidden;margin:0}[_nghost-%COMP%]   img[_ngcontent-%COMP%]{position:absolute;left:50%;top:50%;width:auto;height:100%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}[_nghost-%COMP%]   img.portrait[_ngcontent-%COMP%]{width:100%;height:auto}"]
    });
  }
  return ImageHolderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ThumbComponent = /*#__PURE__*/(() => {
  class ThumbComponent {
    el;
    height;
    src;
    isPortrait;
    hostHeight;
    constructor(el) {
      this.el = el;
    }
    ngOnInit() {
      // console.log(this.height);
      this.hostHeight = this.height;
      this.isPortrait = false;
    }
    ngAfterViewInit() {
      const img = new Image();
      img.addEventListener('load', result => {
        const el = this.el.nativeElement;
        const elWidth = el.clientWidth;
        const elHeight = el.clientHeight;
        this.isPortrait = false;
        // console.log('el width x el height', elWidth, elHeight);
        // if (img.naturalWidth > 300) {
        // 	console.table({
        // 		path: img.src,
        // 		dimension: img.naturalWidth + ' x ' + img.naturalHeight
        // 	});
        // }
        const imgWidth = img.naturalWidth;
        const imgHeight = img.naturalHeight;
        const calcHeight = imgHeight / elHeight;
        // console.log('calcHeight', calcHeight);
        // console.log('calcHeight2', Math.round(imgHeight / calcHeight));
        const calcWidth = imgWidth / calcHeight;
        // console.log('elHeight', elHeight);
        // console.log('elWidth', elWidth);
        // console.log('imgWidth', imgWidth);
        // console.log('calcWidth', calcWidth);
        if (calcWidth <= elWidth) {
          this.isPortrait = true;
        }
        if (imgHeight >= imgWidth) {
          this.isPortrait = true;
        }
      });
      img.src = this.src;
    }
    static ɵfac = function ThumbComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ThumbComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ThumbComponent,
      selectors: [["thumb"]],
      hostVars: 2,
      hostBindings: function ThumbComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵstyleProp("height", ctx.hostHeight);
        }
      },
      inputs: {
        height: "height",
        src: "src"
      },
      decls: 1,
      vars: 1,
      consts: [[4, "ngIf"], [3, "src"]],
      template: function ThumbComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ThumbComponent_ng_container_0_Template, 2, 3, "ng-container", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.src);
        }
      },
      dependencies: [i2.NgIf],
      styles: ["[_nghost-%COMP%]{display:block;position:relative;overflow:hidden;border-radius:3px;margin:0;width:100%}[_nghost-%COMP%]   img[_ngcontent-%COMP%]{position:absolute;left:50%;top:50%;width:auto;height:100%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}[_nghost-%COMP%]   img.portrait[_ngcontent-%COMP%]{width:100%;height:auto}"]
    });
  }
  return ThumbComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ImageViewerComponent = /*#__PURE__*/(() => {
  class ImageViewerComponent {
    dialogRef;
    data;
    config = {
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide'
      },
      direction: 'horizontal',
      slidesPerView: 1,
      keyboard: true,
      mousewheel: true,
      scrollbar: false,
      navigation: false,
      pagination: true,
      loop: true
    };
    images = [];
    constructor(dialogRef, data) {
      this.dialogRef = dialogRef;
      this.data = data;
    }
    ngOnInit() {
      this.images = this.data.images;
    }
    static ɵfac = function ImageViewerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ImageViewerComponent)(i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ImageViewerComponent,
      selectors: [["app-image-viewer"]],
      decls: 2,
      vars: 8,
      consts: [[3, "counter", "slideToShow", "slideToScroll", "dots", "autoPlay", "displayAutoPlayControls", "autoPlayAtStart"], [4, "ngFor", "ngForOf"], [1, "carousel-slide"], ["height", "600px", 3, "src"]],
      template: function ImageViewerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "carousel", 0);
          i0.ɵɵtemplate(1, ImageViewerComponent_ng_container_1_Template, 3, 1, "ng-container", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("counter", false)("slideToShow", 1)("slideToScroll", 1)("dots", false)("autoPlay", true)("displayAutoPlayControls", false)("autoPlayAtStart", true);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.images);
        }
      },
      dependencies: [i2.NgForOf, i3$1.CarouselComponent, ThumbComponent],
      styles: [".swiper-slide[_ngcontent-%COMP%]{overflow:hidden!important}.thumb[_ngcontent-%COMP%]{position:relative;width:800px;height:600px;overflow:hidden}.image-descs[_ngcontent-%COMP%]{position:absolute;bottom:0;height:90px;left:0;right:0;background:linear-gradient(#0003,#000000e6);padding:15px}.image-descs[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#fff;font-weight:300}.image-descs[_ngcontent-%COMP%]   h5.image-title[_ngcontent-%COMP%]{font-size:18px;margin:0}.image-descs[_ngcontent-%COMP%]   h5.image-remark[_ngcontent-%COMP%]{font-size:12px}"]
    });
  }
  return ImageViewerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LoadingButtonComponent = /*#__PURE__*/(() => {
  class LoadingButtonComponent {
    type = 'button';
    isDisabled = false;
    isLoading = false;
    loadingText = 'Loading...';
    className = 'btn-primary';
    title;
    constructor() {}
    ngOnInit() {}
    static ɵfac = function LoadingButtonComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LoadingButtonComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: LoadingButtonComponent,
      selectors: [["loading-button"]],
      inputs: {
        type: "type",
        isDisabled: "isDisabled",
        isLoading: "isLoading",
        loadingText: "loadingText",
        className: "className",
        title: "title"
      },
      ngContentSelectors: _c0,
      decls: 3,
      vars: 6,
      consts: [["fxFlex", "", 1, "btn", "btn-loading", 3, "ngClass", "type", "disabled", "title"], [4, "ngIf"], ["role", "status", "aria-hidden", "true", 1, "spinner-border", "spinner-border-sm", "me-2"], ["role", "status", "aria-hidden", "true", 1, "spinner-border", "spinner-border-sm"]],
      template: function LoadingButtonComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "button", 0);
          i0.ɵɵtemplate(1, LoadingButtonComponent_ng_container_1_Template, 3, 2, "ng-container", 1)(2, LoadingButtonComponent_ng_container_2_Template, 2, 0, "ng-container", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", ctx.className)("type", ctx.type)("disabled", ctx.isDisabled || ctx.isLoading)("title", ctx.title);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.isLoading);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.isLoading);
        }
      },
      dependencies: [i2.NgClass, i2.NgIf, i3.DefaultFlexDirective, i4.DefaultClassDirective],
      styles: ["button.btn.btn-loading{flex:1 1 0%;box-sizing:border-box}.spinner-border[_ngcontent-%COMP%]{color:#fff;vertical-align:middle;margin-bottom:2px}.btn-comment[_ngcontent-%COMP%]{border-bottom-right-radius:0!important;border-top-right-radius:0!important;margin-right:.1em!important}"]
    });
  }
  return LoadingButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NotificationComponent = /*#__PURE__*/(() => {
  class NotificationComponent {
    router;
    snackBarRef;
    data;
    notificationId;
    notificationTypeName = 'Notification Type';
    title = 'Your title goes here';
    message = 'Your message goes here';
    route = '/';
    color = '007bff';
    icon = 'fas fa-times';
    startSound;
    soundSrc;
    constructor(router, snackBarRef, data) {
      this.router = router;
      this.snackBarRef = snackBarRef;
      this.data = data;
    }
    ngOnInit() {
      if (this.data.soundSrc) {
        this.soundSrc = this.data.soundSrc;
        this.startSound = document.getElementById('startSound');
        this.startSound.play();
      }
      console.log('snackbar', this.data);
      this.notificationId = this.data.notificationId;
      this.notificationTypeName = this.data.notificationTypeName;
      this.title = this.data.title;
      this.message = this.data.message;
      this.route = this.data.route;
      this.color = this.data.color;
      this.icon = this.data.icon;
    }
    open() {
      this.router.navigate([this.route]).then(() => this.close());
    }
    close() {
      this.snackBarRef.dismiss();
    }
    static ɵfac = function NotificationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NotificationComponent)(i0.ɵɵdirectiveInject(i1$1.Router), i0.ɵɵdirectiveInject(i2$3.MatSnackBarRef), i0.ɵɵdirectiveInject(MAT_SNACK_BAR_DATA));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NotificationComponent,
      selectors: [["notification"]],
      decls: 13,
      vars: 8,
      consts: [["fxLayoutAlign", "start center", "fxLayoutGap", "20px", "fxFlex", "", 1, "notification-container", 3, "click", "routerLink"], [3, "ngClass"], ["fxLayout", "column", "fxLayoutAlign", "center start", "fxFlex", ""], [1, "notification-type"], [1, "title"], [1, "message"], ["fxLayout", "column", "fxLayoutAlign", "center center", 1, "notification-close"], [1, "fas", "fa-times", 3, "click"], ["id", "startSound"], [3, "src"]],
      template: function NotificationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "a", 0);
          i0.ɵɵlistener("click", function NotificationComponent_Template_a_click_0_listener() {
            return ctx.open();
          });
          i0.ɵɵelement(1, "i", 1);
          i0.ɵɵelementStart(2, "div", 2)(3, "h6", 3);
          i0.ɵɵtext(4);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "h6", 4);
          i0.ɵɵtext(6);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(7, "h6", 5);
          i0.ɵɵtext(8);
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(9, "div", 6)(10, "i", 7);
          i0.ɵɵlistener("click", function NotificationComponent_Template_i_click_10_listener() {
            return ctx.close();
          });
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(11, "audio", 8);
          i0.ɵɵelement(12, "source", 9);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("routerLink", ctx.route);
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("background-color", "#" + ctx.color);
          i0.ɵɵproperty("ngClass", ctx.icon);
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(ctx.notificationTypeName);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.title);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.message);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("src", ctx.soundSrc, i0.ɵɵsanitizeUrl);
        }
      },
      dependencies: [i2.NgClass, i3.DefaultLayoutDirective, i3.DefaultLayoutGapDirective, i3.DefaultLayoutAlignDirective, i3.DefaultFlexDirective, i4.DefaultClassDirective, i1$1.RouterLink],
      styles: ["[_nghost-%COMP%]{border-radius:8px}.notification-container[_ngcontent-%COMP%]{flex-direction:row;box-sizing:border-box;display:flex;padding:20px;cursor:pointer}.notification-container[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-size:20px;width:40px;height:40px;line-height:40px;text-align:center;background-color:var(--bs-primary);color:#fff;border-radius:50%}.notification-container[_ngcontent-%COMP%]   .notification-type[_ngcontent-%COMP%]{font-weight:700;margin-bottom:2px}.notification-container[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#000;margin-bottom:2px}.notification-container[_ngcontent-%COMP%]   .message[_ngcontent-%COMP%]{color:var(--bs-secondary)}.notification-close[_ngcontent-%COMP%]{margin-left:20px}.notification-close[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-size:20px;width:40px;height:40px;line-height:40px;text-align:center;color:var(--bs-secondary);border-radius:8px;margin-right:20px;cursor:pointer}.notification-close[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]:hover{background-color:#f2f2f2}"]
    });
  }
  return NotificationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DialogComponent = /*#__PURE__*/(() => {
  class DialogComponent {
    data;
    dialogRef;
    isInitialized;
    title = '';
    options = new MatTableDataSource();
    displayedColumns = ['no', 'description', 'actions'];
    search = new FormControl();
    optionTemplate;
    showPaginator = false;
    onAdd;
    paginator;
    constructor(data, dialogRef) {
      this.data = data;
      this.dialogRef = dialogRef;
    }
    ngOnInit() {
      console.log('option dialog data', this.data);
      this.isInitialized = false;
      this.title = this.data.title;
      this.optionTemplate = this.data.optionTemplate;
      this.showPaginator = this.data.showPaginator || false;
      this.onAdd = this.data.onAdd;
      this.search.valueChanges.subscribe(result => {
        this.options.filter = result?.toLowerCase().trim();
      });
      this.data.options.toPromise().then(options => {
        console.log('options', options);
        this.options.data = options.map((o, i) => Object.assign(o, {
          no: i + 1
        }));
        if (this.showPaginator) {
          this.options.paginator = this.paginator;
        }
        this.isInitialized = true;
      });
      // this.onAdd.subscribe((result: any) => {
      // 	console.log('this.onAdd.subscribe', result);
      // });
    }
    select(option) {
      this.dialogRef.close(option);
    }
    add() {
      if (this.onAdd) {
        this.onAdd.emit();
      }
      this.dialogRef.close();
    }
    static ɵfac = function DialogComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DialogComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i1.MatDialogRef));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DialogComponent,
      selectors: [["app-dialog"]],
      viewQuery: function DialogComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(MatPaginator, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paginator = _t.first);
        }
      },
      decls: 14,
      vars: 6,
      consts: [["dataGrid", ""], ["mat-dialog-title", "", 4, "ngIf"], ["fxLayout", "column", 1, "py-3"], ["fxFlex", "", 1, "form-group", "mb-0"], [1, "input-group"], ["type", "text", "placeholder", "Search..", 1, "form-control", 3, "formControl"], [1, "input-group-text"], [1, "fas", "fa-search"], ["fxLayout", "column", 1, "p-0"], [4, "ngIf"], ["fxLayout", "", "fxLayoutGap", "10px", 4, "ngIf"], ["mat-dialog-title", ""], ["matSort", "", "matSortDisableClear", "", 1, "data-grid", "scroll", "scroll-y", 3, "dataSource"], ["matColumnDef", "no"], ["fxFlex", "60px", "mat-sort-header", "", 4, "matHeaderCellDef"], ["fxFlex", "60px", 4, "matCellDef"], ["matColumnDef", "description"], ["fxFlex", "", "mat-sort-header", "", 4, "matHeaderCellDef"], ["fxFlex", "", 4, "matCellDef"], ["matColumnDef", "actions"], ["fxFlex", "48px", 4, "matHeaderCellDef"], ["fxFlex", "48px", 4, "matCellDef"], [4, "matHeaderRowDef", "matHeaderRowDefSticky"], [4, "matRowDef", "matRowDefColumns"], ["fxFlex", "60px", "mat-sort-header", ""], ["fxFlex", "60px"], ["fxFlex", "", "mat-sort-header", ""], ["fxFlex", ""], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["fxFlex", "48px"], [1, "btn", "btn-primary", "btn-sm", 3, "click"], [1, "fas", "fa-check"], ["fxFlex", "200px"], ["showFirstLastButtons", "", 3, "pageSizeOptions"], ["fxLayout", "", "fxLayoutGap", "10px"], [1, "btn", "btn-primary", "btn-block", "w-100", 3, "click"], [1, "fas", "fa-plus", "me-2"]],
      template: function DialogComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, DialogComponent_h2_0_Template, 2, 1, "h2", 1);
          i0.ɵɵelementStart(1, "mat-dialog-content", 2)(2, "div", 3)(3, "label");
          i0.ɵɵtext(4, "Search");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "div", 4);
          i0.ɵɵelement(6, "input", 5);
          i0.ɵɵelementStart(7, "span", 6);
          i0.ɵɵelement(8, "i", 7);
          i0.ɵɵelementEnd()()()();
          i0.ɵɵelementStart(9, "mat-dialog-content", 8);
          i0.ɵɵtemplate(10, DialogComponent_ng_container_10_Template, 14, 4, "ng-container", 9)(11, DialogComponent_ng_container_11_Template, 2, 0, "ng-container", 9)(12, DialogComponent_ng_container_12_Template, 2, 2, "ng-container", 9);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(13, DialogComponent_mat_dialog_actions_13_Template, 4, 0, "mat-dialog-actions", 10);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.title);
          i0.ɵɵadvance(6);
          i0.ɵɵproperty("formControl", ctx.search);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("ngIf", ctx.isInitialized);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.isInitialized);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showPaginator);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.onAdd);
        }
      },
      dependencies: [i2.NgIf, i2.NgTemplateOutlet, i1.MatDialogTitle, i1.MatDialogActions, i1.MatDialogContent, i3$2.MatTable, i3$2.MatHeaderCellDef, i3$2.MatHeaderRowDef, i3$2.MatColumnDef, i3$2.MatCellDef, i3$2.MatRowDef, i3$2.MatHeaderCell, i3$2.MatCell, i3$2.MatHeaderRow, i3$2.MatRow, i4$1.MatPaginator, i3.DefaultLayoutDirective, i3.DefaultLayoutGapDirective, i3.DefaultFlexDirective, i2$2.DefaultValueAccessor, i2$2.NgControlStatus, i2$2.FormControlDirective, LoadingComponent],
      styles: [".data-grid[_ngcontent-%COMP%]{max-height:400px}"]
    });
  }
  return DialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OptionDirective = /*#__PURE__*/(() => {
  class OptionDirective {
    static ɵfac = function OptionDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OptionDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: OptionDirective,
      selectors: [["", "option", ""]]
    });
  }
  return OptionDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OptionRowDirective = /*#__PURE__*/(() => {
  class OptionRowDirective {
    templateRef;
    constructor(templateRef) {
      this.templateRef = templateRef;
    }
    static ɵfac = function OptionRowDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OptionRowDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: OptionRowDirective,
      selectors: [["", "optionRow", ""]]
    });
  }
  return OptionRowDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OptionDialogComponent = /*#__PURE__*/(() => {
  class OptionDialogComponent {
    dialog;
    title = '';
    placeholder = '';
    options;
    initialValue;
    valueName = 'optionName';
    addOption = false;
    isInvalid = false;
    readonly = false;
    paginator = false;
    // @Output() add: EventEmitter<T> = this.readonly ? null : new EventEmitter<T>();
    // @Output() onSelect: EventEmitter<T> = this.readonly ? null : new EventEmitter<T>();
    add = new EventEmitter();
    onSelect = new EventEmitter();
    optionTemplate;
    option;
    disabled = this.readonly;
    touched = false;
    onTouched = t => {};
    onChanged = t => {};
    constructor(dialog) {
      this.dialog = dialog;
    }
    ngOnInit() {
      this.option = this.initialValue;
    }
    openDialog() {
      this.markAsTouched();
      this.dialog.open(DialogComponent, {
        width: '500px',
        data: {
          title: this.title,
          options: this.options,
          onAdd: this.addOption && !this.readonly ? this.add : null,
          optionTemplate: this.optionTemplate,
          showPaginator: !!this.paginator
        }
      }).afterClosed().subscribe(option => {
        if (option) {
          this.writeValue(option);
          this.onChanged(option);
          if (!this.readonly) {
            this.onSelect.emit(option);
          }
        }
      });
    }
    writeValue(option) {
      this.option = option;
    }
    registerOnChange(fn) {
      this.onChanged = fn; // <-- save the function
    }
    registerOnTouched(fn) {
      this.onTouched = fn; // <-- save the function
    }
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    markAsTouched() {
      if (!this.touched) {
        this.onTouched(this.option);
        this.touched = true;
      }
    }
    get displayedValue() {
      return this.option ? this.option[this.valueName] : this.initialValue ? this.initialValue[this.valueName] : null;
    }
    static ɵfac = function OptionDialogComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OptionDialogComponent)(i0.ɵɵdirectiveInject(i1.MatDialog));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OptionDialogComponent,
      selectors: [["option-dialog"]],
      contentQueries: function OptionDialogComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, OptionDirective, 7, TemplateRef);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.optionTemplate = _t.first);
        }
      },
      hostBindings: function OptionDialogComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("change", function OptionDialogComponent_change_HostBindingHandler() {
            return ctx.onChange();
          });
        }
      },
      inputs: {
        title: "title",
        placeholder: "placeholder",
        options: "options",
        initialValue: "initialValue",
        valueName: "valueName",
        addOption: "addOption",
        isInvalid: "isInvalid",
        readonly: "readonly",
        paginator: "paginator"
      },
      outputs: {
        add: "add",
        onSelect: "onSelect"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        multi: true,
        useExisting: forwardRef(() => OptionDialogComponent)
      }])],
      decls: 4,
      vars: 7,
      consts: [[1, "input-group"], ["ngDefaultControl", "", "readonly", "", 1, "form-control", 3, "ngModel", "placeholder", "disabled"], [4, "ngIf"], [1, "input-group-text"], [1, "fas", "fa-ellipsis-h"], ["type", "button", 1, "btn", "btn-primary", 3, "click"]],
      template: function OptionDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵelement(1, "input", 1);
          i0.ɵɵtemplate(2, OptionDialogComponent_ng_container_2_Template, 3, 0, "ng-container", 2)(3, OptionDialogComponent_ng_container_3_Template, 3, 0, "ng-container", 2);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵclassProp("is-invalid", ctx.isInvalid);
          i0.ɵɵproperty("ngModel", ctx.displayedValue)("placeholder", ctx.placeholder)("disabled", ctx.readonly);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.readonly);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.readonly);
        }
      },
      dependencies: [i2.NgIf, i2$2.DefaultValueAccessor, i2$2.NgControlStatus, i2$2.NgModel]
    });
  }
  return OptionDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PageBodyComponent = /*#__PURE__*/(() => {
  class PageBodyComponent {
    containerFluid = true;
    constructor() {}
    ngOnInit() {}
    static ɵfac = function PageBodyComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PageBodyComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: PageBodyComponent,
      selectors: [["page-body"]],
      hostVars: 2,
      hostBindings: function PageBodyComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("container-fluid", ctx.containerFluid);
        }
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function PageBodyComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{flex-direction:column;box-sizing:border-box;display:flex;padding:20px;position:relative}[_nghost-%COMP%]   .loading-container[_ngcontent-%COMP%]{position:relative;min-height:550px}"]
    });
  }
  return PageBodyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PanelComponent = /*#__PURE__*/(() => {
  class PanelComponent {
    constructor() {}
    static ɵfac = function PanelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PanelComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: PanelComponent,
      selectors: [["panel"]],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function PanelComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{flex-direction:column;box-sizing:border-box;display:flex;border:1px solid #dfe3e9;background-color:#fff;border-radius:8px;border-collapse:collapse;position:relative;padding:0;overflow:hidden;margin-bottom:20px}  panel-header{padding:25px 22px;border-bottom:1px solid #e6eaee}  panel-header .panel-title{font-size:20px;font-weight:500;margin:0}  panel-filter{padding:10px 22px;border-bottom:1px solid #e6eaee;place-content:flex-end flex-start;align-items:flex-end;flex-direction:row;box-sizing:border-box;display:flex}  panel-filter .form-group{margin-bottom:0}  panel-filter .form-group label{font-size:12px;margin-bottom:0}  panel-filter>*:not(:last-child){margin-right:10px}  panel-filter>*:last-child{margin-right:0}@media screen and (max-width: 960px){  panel-filter{flex-direction:column;place-content:unset;align-items:unset}}  panel-body{padding:30px 22px;border-bottom:1px solid #e6eaee}  panel-body:last-child{border-bottom:none}  panel-body .loading-container{position:relative;min-height:550px}  panel-footer{padding:12px 22px}"]
    });
  }
  return PanelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PanelHeaderComponent = /*#__PURE__*/(() => {
  class PanelHeaderComponent {
    title;
    constructor() {}
    static ɵfac = function PanelHeaderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PanelHeaderComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: PanelHeaderComponent,
      selectors: [["panel-header"]],
      inputs: {
        title: "title"
      },
      decls: 2,
      vars: 1,
      consts: [[1, "panel-title"]],
      template: function PanelHeaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "h1", 0);
          i0.ɵɵtext(1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate(ctx.title);
        }
      },
      encapsulation: 2
    });
  }
  return PanelHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PanelFilterComponent = /*#__PURE__*/(() => {
  class PanelFilterComponent {
    constructor() {}
    static ɵfac = function PanelFilterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PanelFilterComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: PanelFilterComponent,
      selectors: [["panel-filter"]],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function PanelFilterComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
  return PanelFilterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PanelBodyComponent = /*#__PURE__*/(() => {
  class PanelBodyComponent {
    constructor() {}
    static ɵfac = function PanelBodyComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PanelBodyComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: PanelBodyComponent,
      selectors: [["panel-body"]],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function PanelBodyComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
  return PanelBodyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PanelFooterComponent = /*#__PURE__*/(() => {
  class PanelFooterComponent {
    constructor() {}
    static ɵfac = function PanelFooterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PanelFooterComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: PanelFooterComponent,
      selectors: [["panel-footer"]],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function PanelFooterComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
  return PanelFooterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ProgressChartComponent = /*#__PURE__*/(() => {
  class ProgressChartComponent {
    value;
    max;
    valueColor = '#000000';
    maxColor = '#DFE7EC';
    height = 3;
    width = 0;
    constructor() {}
    ngOnInit() {
      // console.log('valuePercent', this.value, this.max, this.valuePercent);
    }
    getValuePercent() {
      return this.value / this.max * 100;
    }
    static ɵfac = function ProgressChartComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProgressChartComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ProgressChartComponent,
      selectors: [["progress-chart"]],
      inputs: {
        value: "value",
        max: "max",
        valueColor: "valueColor",
        maxColor: "maxColor",
        height: "height",
        width: "width"
      },
      decls: 2,
      vars: 14,
      consts: [[1, "progress-chart"], [1, "chart-value"]],
      template: function ProgressChartComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵelement(1, "div", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵstyleProp("width", ctx.width === 0 ? "" : ctx.width)("background", ctx.maxColor)("border-radius", ctx.height / 2, "px");
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("width", ctx.getValuePercent() + "%")("background", ctx.valueColor)("height", ctx.height, "px")("border-radius", ctx.height / 2, "px");
        }
      },
      styles: ["[_nghost-%COMP%]{width:100%;display:block}[_nghost-%COMP%]   .progress-chart[_ngcontent-%COMP%]{display:block;overflow:hidden}[_nghost-%COMP%]   .progress-chart[_ngcontent-%COMP%]   .chart-value[_ngcontent-%COMP%]{height:100%}"]
    });
  }
  return ProgressChartComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ReasonComponent = /*#__PURE__*/(() => {
  class ReasonComponent {
    dialogRef;
    data;
    formBuilder;
    formGroup;
    reason;
    title;
    placeholder = 'reason';
    formSubmitAttempt;
    constructor(dialogRef, data, formBuilder) {
      this.dialogRef = dialogRef;
      this.data = data;
      this.formBuilder = formBuilder;
    }
    ngOnInit() {
      this.title = this.data.title;
      this.placeholder = this.data.placeholder;
      this.reason = new FormControl(null, [Validators.required]);
      this.formGroup = this.formBuilder.group({
        reason: this.reason
      });
    }
    submit() {
      this.formSubmitAttempt = true;
      if (this.formGroup.invalid) {
        return;
      }
      this.dialogRef.close(this.reason.value);
    }
    static ɵfac = function ReasonComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReasonComponent)(i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i2$2.FormBuilder));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ReasonComponent,
      selectors: [["app-reason"]],
      decls: 14,
      vars: 5,
      consts: [["mat-dialog-title", ""], ["fxLayout", "column"], ["novalidate", "", "fxLayout", "column", 1, "needs-validation", 3, "ngSubmit", "formGroup"], [1, "form-group", "mb-0"], ["formControlName", "reason", "rows", "5", 1, "form-control", 3, "placeholder"], ["fxLayout", "", "fxLayoutGap", "10px"], ["fxFlex", ""], [1, "btn", "btn-primary", 3, "click"], [1, "fa", "fa-save", "me-1"], ["mat-dialog-close", "", 1, "btn", "btn-danger"], [1, "fa", "fa-times", "me-1"]],
      template: function ReasonComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "h5", 0);
          i0.ɵɵtext(1);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(2, "mat-dialog-content", 1)(3, "form", 2);
          i0.ɵɵlistener("ngSubmit", function ReasonComponent_Template_form_ngSubmit_3_listener() {
            return ctx.submit();
          });
          i0.ɵɵelementStart(4, "div", 3);
          i0.ɵɵelement(5, "textarea", 4);
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(6, "mat-dialog-actions", 5);
          i0.ɵɵelement(7, "span", 6);
          i0.ɵɵelementStart(8, "button", 7);
          i0.ɵɵlistener("click", function ReasonComponent_Template_button_click_8_listener() {
            return ctx.submit();
          });
          i0.ɵɵelement(9, "i", 8);
          i0.ɵɵtext(10, " Save ");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(11, "button", 9);
          i0.ɵɵelement(12, "i", 10);
          i0.ɵɵtext(13, " Close ");
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate(ctx.title);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("formGroup", ctx.formGroup);
          i0.ɵɵadvance(2);
          i0.ɵɵclassProp("is-invalid", ctx.reason.invalid && ctx.formSubmitAttempt);
          i0.ɵɵproperty("placeholder", ctx.placeholder);
        }
      },
      dependencies: [i2$2.ɵNgNoValidate, i2$2.DefaultValueAccessor, i2$2.NgControlStatus, i2$2.NgControlStatusGroup, i2$2.FormGroupDirective, i2$2.FormControlName, i1.MatDialogClose, i1.MatDialogTitle, i1.MatDialogActions, i1.MatDialogContent, i3.DefaultLayoutDirective, i3.DefaultLayoutGapDirective, i3.DefaultFlexDirective]
    });
  }
  return ReasonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SingleInputDialogComponent = /*#__PURE__*/(() => {
  class SingleInputDialogComponent {
    formBuilder;
    dialogRef;
    data;
    title = '';
    label = '';
    placeholder = '';
    formGroup;
    formControl;
    formSubmitAttempt = false;
    mask;
    constructor(formBuilder, dialogRef, data) {
      this.formBuilder = formBuilder;
      this.dialogRef = dialogRef;
      this.data = data;
    }
    ngOnInit() {
      this.formSubmitAttempt = false;
      this.formControl = new FormControl(null, [Validators.required]);
      this.formGroup = this.formBuilder.group({
        formControl: this.formControl
      });
      this.title = this.data.title;
      this.label = this.data.label;
      this.placeholder = this.data.placeholder;
      this.mask = this.data.mask;
    }
    submit() {
      this.formSubmitAttempt = true;
      if (this.formGroup.invalid) {
        return;
      }
      const data = this.formControl.value;
      if (this.data && this.data.mask === 'uppercase') {
        return this.dialogRef.close(data?.toUpperCase());
      }
      return this.dialogRef.close(data);
    }
    static ɵfac = function SingleInputDialogComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SingleInputDialogComponent)(i0.ɵɵdirectiveInject(i2$2.FormBuilder), i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SingleInputDialogComponent,
      selectors: [["app-single-input-dialog"]],
      decls: 16,
      vars: 7,
      consts: [["mat-dialog-title", ""], ["fxLayout", "column"], ["novalidate", "", "fxLayout", "column", 1, "needs-validation", 3, "ngSubmit", "formGroup"], [1, "form-group", "mb-0", "required"], ["formControlName", "formControl", 1, "form-control", 3, "iMask", "placeholder"], ["fxLayout", "", "fxLayoutGap", "10px"], ["fxFlex", ""], [1, "btn", "btn-primary", 3, "click"], [1, "fa", "fa-save", "me-1"], ["mat-dialog-close", "", 1, "btn", "btn-danger"], [1, "fa", "fa-times", "me-1"]],
      template: function SingleInputDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "h2", 0);
          i0.ɵɵtext(1);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(2, "mat-dialog-content", 1)(3, "form", 2);
          i0.ɵɵlistener("ngSubmit", function SingleInputDialogComponent_Template_form_ngSubmit_3_listener() {
            return ctx.submit();
          });
          i0.ɵɵelementStart(4, "div", 3)(5, "label");
          i0.ɵɵtext(6);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(7, "input", 4);
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(8, "mat-dialog-actions", 5);
          i0.ɵɵelement(9, "span", 6);
          i0.ɵɵelementStart(10, "button", 7);
          i0.ɵɵlistener("click", function SingleInputDialogComponent_Template_button_click_10_listener() {
            return ctx.submit();
          });
          i0.ɵɵelement(11, "i", 8);
          i0.ɵɵtext(12, " Save ");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(13, "button", 9);
          i0.ɵɵelement(14, "i", 10);
          i0.ɵɵtext(15, " Close ");
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate(ctx.title);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("formGroup", ctx.formGroup);
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(ctx.label);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("is-invalid", ctx.formControl.invalid && ctx.formSubmitAttempt);
          i0.ɵɵproperty("iMask", ctx.mask)("placeholder", ctx.placeholder);
        }
      },
      dependencies: [i1.MatDialogClose, i1.MatDialogTitle, i1.MatDialogActions, i1.MatDialogContent, i3.DefaultLayoutDirective, i3.DefaultLayoutGapDirective, i3.DefaultFlexDirective, i2$2.ɵNgNoValidate, i2$2.DefaultValueAccessor, i2$2.NgControlStatus, i2$2.NgControlStatusGroup, i2$2.FormGroupDirective, i2$2.FormControlName, i4$2.IMaskDirective]
    });
  }
  return SingleInputDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AlertModule = /*#__PURE__*/(() => {
  class AlertModule {
    static ɵfac = function AlertModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AlertModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: AlertModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, MatDialogModule, FlexLayoutModule]
    });
  }
  return AlertModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LoadingModule = /*#__PURE__*/(() => {
  class LoadingModule {
    static ɵfac = function LoadingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LoadingModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: LoadingModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
  return LoadingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChartModule = /*#__PURE__*/(() => {
  class ChartModule {
    static ɵfac = function ChartModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChartModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ChartModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, NgChartsModule, LoadingModule]
    });
  }
  return ChartModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ConfirmModule = /*#__PURE__*/(() => {
  class ConfirmModule {
    static ɵfac = function ConfirmModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ConfirmModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ConfirmModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, MatDialogModule, FlexLayoutModule]
    });
  }
  return ConfirmModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ErrorMessageModule = /*#__PURE__*/(() => {
  class ErrorMessageModule {
    static ɵfac = function ErrorMessageModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ErrorMessageModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ErrorMessageModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
  return ErrorMessageModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DeleteModule = /*#__PURE__*/(() => {
  class DeleteModule {
    static ɵfac = function DeleteModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DeleteModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DeleteModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, MatDialogModule, FlexLayoutModule, FormsModule, ReactiveFormsModule, ErrorMessageModule]
    });
  }
  return DeleteModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ImageHolderModule = /*#__PURE__*/(() => {
  class ImageHolderModule {
    static ɵfac = function ImageHolderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ImageHolderModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ImageHolderModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
  return ImageHolderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ThumbModule = /*#__PURE__*/(() => {
  class ThumbModule {
    static ɵfac = function ThumbModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ThumbModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ThumbModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
  return ThumbModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ImageViewerModule = /*#__PURE__*/(() => {
  class ImageViewerModule {
    static ɵfac = function ImageViewerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ImageViewerModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ImageViewerModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, CarouselModule, ThumbModule]
    });
  }
  return ImageViewerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LoadingButtonModule = /*#__PURE__*/(() => {
  class LoadingButtonModule {
    static ɵfac = function LoadingButtonModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LoadingButtonModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: LoadingButtonModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FlexLayoutModule]
    });
  }
  return LoadingButtonModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NotificationModule = /*#__PURE__*/(() => {
  class NotificationModule {
    static ɵfac = function NotificationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NotificationModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NotificationModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FlexLayoutModule, RouterModule]
    });
  }
  return NotificationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SingleInputDialogModule = /*#__PURE__*/(() => {
  class SingleInputDialogModule {
    static ɵfac = function SingleInputDialogModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SingleInputDialogModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SingleInputDialogModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, MatDialogModule, FlexLayoutModule, ReactiveFormsModule, FormsModule, IMaskModule]
    });
  }
  return SingleInputDialogModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OptionDialogModule = /*#__PURE__*/(() => {
  class OptionDialogModule {
    static ɵfac = function OptionDialogModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OptionDialogModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: OptionDialogModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, MatDialogModule, MatTableModule, MatPaginatorModule, FlexLayoutModule, FormsModule, ReactiveFormsModule, SingleInputDialogModule, LoadingModule]
    });
  }
  return OptionDialogModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PageModule = /*#__PURE__*/(() => {
  class PageModule {
    static ɵfac = function PageModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PageModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: PageModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
  return PageModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PanelModule = /*#__PURE__*/(() => {
  class PanelModule {
    static ɵfac = function PanelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PanelModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: PanelModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
  return PanelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ProgressChartModule = /*#__PURE__*/(() => {
  class ProgressChartModule {
    static ɵfac = function ProgressChartModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProgressChartModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ProgressChartModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
  return ProgressChartModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ReasonModule = /*#__PURE__*/(() => {
  class ReasonModule {
    static ɵfac = function ReasonModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReasonModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ReasonModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FormsModule, ReactiveFormsModule, MatDialogModule, FlexLayoutModule]
    });
  }
  return ReasonModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MaterialModule = /*#__PURE__*/(() => {
  class MaterialModule {
    static ɵfac = function MaterialModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MaterialModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MaterialModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [MatButtonModule, MatButtonToggleModule, MatCheckboxModule, MatCardModule, MatSidenavModule, MatToolbarModule, MatIconModule, MatMenuModule, MatTableModule, MatTabsModule, MatListModule, MatDialogModule, MatPaginatorModule, MatTreeModule, MatDatepickerModule, MatNativeDateModule, MatSnackBarModule, MatSortModule, MatSliderModule, DragDropModule, MatInputModule, MatSlideToggleModule, ScrollingModule, MatButtonModule, MatButtonToggleModule, MatCheckboxModule, MatCardModule, MatSidenavModule, MatToolbarModule, MatIconModule, MatMenuModule, MatTableModule, MatTabsModule, MatListModule, MatDialogModule, MatPaginatorModule, MatTreeModule, MatDatepickerModule, MatNativeDateModule, MatSnackBarModule, MatSortModule, MatSliderModule, DragDropModule, MatInputModule, MatSlideToggleModule, ScrollingModule]
    });
  }
  return MaterialModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const autoplay = {
  delay: 2000,
  stopOnLastSlide: false
};
let UiModule = /*#__PURE__*/(() => {
  class UiModule {
    static ɵfac = function UiModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UiModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: UiModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [AlertModule, ChartModule, ConfirmModule, DeleteModule, ErrorMessageModule, FlexLayoutModule, ImageHolderModule, ImageViewerModule, LoadingButtonModule, LoadingModule, MaterialModule, NgbModule, NotificationModule, OptionDialogModule, PageModule, PanelModule, ProgressChartModule, ReasonModule, SingleInputDialogModule, CarouselModule, ThumbModule, AlertModule, ConfirmModule, ChartModule, DeleteModule, ErrorMessageModule, FlexLayoutModule, ImageHolderModule, ImageViewerModule, LoadingButtonModule, LoadingModule, MaterialModule, NgbModule, NotificationModule, OptionDialogModule, PageModule, PanelModule, ProgressChartModule, ReasonModule, SingleInputDialogModule, CarouselModule, ThumbModule]
    });
  }
  return UiModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ui
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AlertComponent, AlertModule, BarComponent, ChartModule, ConfirmComponent, ConfirmModule, DeleteComponent, DeleteModule, DialogComponent, DoughnutComponent, ErrorMessageComponent, ErrorMessageModule, ImageHolderComponent, ImageHolderModule, ImageViewerComponent, ImageViewerModule, LegendComponent, LoadingButtonComponent, LoadingButtonModule, LoadingComponent, LoadingModule, MaterialModule, NotificationComponent, NotificationModule, OptionDialogComponent, OptionDialogModule, OptionDirective, OptionRowDirective, PageBodyComponent, PageModule, PanelBodyComponent, PanelComponent, PanelFilterComponent, PanelFooterComponent, PanelHeaderComponent, PanelModule, ProgressChartComponent, ProgressChartModule, ReasonComponent, ReasonModule, SingleInputDialogComponent, SingleInputDialogModule, ThumbComponent, ThumbModule, UiModule };
